import React from "react";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";

import "./styles.css";
import { Link } from "react-router-dom";

const SectionWithSwiper = () => {
  // Array de objetos con los datos de cada slide
  const slidesData = [
    {
      imageSrc: "src/prod-Panel.webp",
      title: "Panel Quolsys Touch",
      description:
        "Controla el sistema de seguridad desde un moderno panel touch, navega fácilmente por el menú y las configuraciones de tu alarma, ve los videos de las cámaras y úsalo como marco de fotos."
    },
    {
      imageSrc: "src/climax.webp",
      title: "Panel Climax",
      description:
        "100% Inalámbrico, con botones antipánico y para activación y desactivación de tu equipo."
    },
    {
      imageSrc: "src/prod-Sirena-Ext.webp",
      title: "Central con sirena",
      description:
        "Es el cerebro de tu alarma. Sirena integrada y batería de respaldo con hasta 48hrs de duración ante cortes de energía."
    },
    {
      imageSrc: "src/camara-interior.webp",
      title: "Cámara HD con IA",
      description:
        "Acceso en vivo, audio, deteccion de intrusos, alertas y grabación en la nube."
    },
    {
      imageSrc: "src/prod-Sensor-mov.webp",
      title: "Sensores de movimiento",
      description:
        "Detecta cualquier persona que se mueve en tu casa y dispara la alarma."
    },
    {
      imageSrc: "src/prod-contacto-magnético-interior.webp",
      title: "Contactos magnéticos",
      description:
        "Envía una señal de alarma cuando detecta una apertura de puerta o ventana."
    },
    {
      imageSrc: "src/prod-app.webp",
      title: "App ADT Security",
      description:
        "Controlá tu sistema de alarma, recibí notificaciones, alertas de eventos y mucho más desde tu celu."
    },
    {
      imageSrc: "src/prod-Placa.webp",
      title: "Placa ADT",
      description: "El distintivo de exteriores de ADT indica que tu hogar está protegido con un sistema de alarma con aviso a policía."
    }
  ];

  return (
    <section className="section">
      <div className="container-lg flex flexCol alignCenter">
        <div className="swiperSec">

          <h2 className="textCenter">
            ¿Qué incluyen los <span>packs de seguridad</span>?
          </h2>
          <Swiper
            modules={[Navigation]}
            className="mySwiper"
            spaceBetween={50}
            breakpoints={{
              320: {
                slidesPerView: 1
              },
              640: {
                slidesPerView: 2
              },
              1024: {
                slidesPerView: 3
              }
            }}
            navigation={true}
            loop={true}
          >
            {slidesData.map((slide, index) => (
              <SwiperSlide key={index}>
                <div className="imgBox">
                  <img
                    src={slide.imageSrc}
                    alt={slide.title}
                    width="302"
                    height="487"
                    loading="lazy"
                    decoding="async"
                  />
                  <h3>{slide.title}</h3>
                  <p>{slide.description}</p>
                  <Link to="/cotizador" className="buttonForm">
                    Cotizar ahora
                  </Link>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default SectionWithSwiper;
